(function () {
  'use strict';

  var STORAGE_KEY = 'sedrelle_wishlist';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // Wishlist items are keyed by product HANDLE (not id). The handle is what
  // lets the wishlist page fetch full product data client-side via the
  // public /products/{handle}.js endpoint, which requires no auth.
  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      console.error('Could not save wishlist:', e);
    }
  }

  function isWishlisted(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    qsa('.wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function updateButtonStates() {
    var wishlist = getWishlist();
    qsa('.js-wishlist-toggle').forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      btn.classList.toggle('is-active', wishlist.indexOf(handle) !== -1);
    });
  }

  function toggleProduct(handle) {
    var wishlist = getWishlist();
    var idx = wishlist.indexOf(handle);
    var added;
    if (idx === -1) {
      wishlist.push(handle);
      added = true;
    } else {
      wishlist.splice(idx, 1);
      added = false;
    }
    saveWishlist(wishlist);
    updateCountBadges();
    updateButtonStates();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle: handle, added: added, wishlist: wishlist } }));
    return added;
  }

  function bindButtons() {
    qsa('.js-wishlist-toggle').forEach(function (btn) {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = this.dataset.productHandle;
        if (!handle) return;
        toggleProduct(handle);
      });
    });
  }

  function init() {
    updateCountBadges();
    updateButtonStates();
    bindButtons();

    // Re-run when a collection's "Load more" button appends new product
    // cards, so wishlist buttons on the newly added cards also work.
    document.addEventListener('products:appended', function () {
      bindButtons();
      updateButtonStates();
    });
  }

  // Small public API so other scripts (e.g. the wishlist page renderer)
  // can read/modify the same localStorage-backed list without duplicating
  // this logic.
  window.SedrelleWishlist = {
    getWishlist: getWishlist,
    toggleProduct: toggleProduct,
    isWishlisted: isWishlisted,
    updateCountBadges: updateCountBadges,
    updateButtonStates: updateButtonStates,
    bindButtons: bindButtons
  };

  // wishlist-page.js (and anything else) may load/execute before this
  // script if it happens to appear earlier in the document. Dispatch an
  // event so those scripts don't have to rely on load order to know
  // window.SedrelleWishlist is ready.
  document.dispatchEvent(new CustomEvent('wishlist:ready'));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
